export const LESSON_DATA_SOURCES = [
  "words",
  "grammar",
  "grammarExamples",
  "passages",
  "dialogues",
] as const;

export type LessonDataSource = (typeof LESSON_DATA_SOURCES)[number];

/**
 * `countFrom` names any source the section reads: one of LESSON_DATA_SOURCES, or a sub-list the book
 * lists apart from the main vocabulary ("Real life"), which the author checks and counts on its own.
 */
export type SlideCount =
  | { rule: "perSourceItem"; countFrom: string; each: number }
  | { rule: "fixed"; total: number };

export type LessonDataSourceCounts = Record<LessonDataSource, number> & Record<string, number>;

export function resolveSlideCount(count: SlideCount, counts: LessonDataSourceCounts): number {
  if (count.rule === "fixed") return count.total;
  // A source this lesson does not hold counts for nothing rather than NaN slides.
  return (counts[count.countFrom] ?? 0) * count.each;
}
